<template>
  <div class="p-4 bg-gray-100 min-h-screen">
    <h1 class="text-xl font-bold mb-4">Node Relation Manager</h1>
    <div>
      <StageTreeNode
        v-for="(node, index) in data"
        :key="index"
        :node="node"
        :groupIndex="0"
        :index="index"
        @add-next-stage="addNextStage"
        @add-current-node-data="addCurrentNodeData"
        @delete-node="deleteNode"
      />
    </div>
  </div>
</template>

<script>
import StageTreeNode from "./StageTreeNode.vue";

export default {
  components: { StageTreeNode },
  data() {
    return {
      // 初始化的資料結構
      data: [1],
    };
  },
  methods: {
    // 新增下一階段節點
    addNextStage(groupIndex, index) {
      const currentGroup = this.getGroupByIndex(this.data, groupIndex);
      const currentNode = currentGroup[index];

      // 若當前節點是數字，將其轉為陣列
      if (typeof currentNode === "number") {
        currentGroup.splice(index, 1, [currentNode]);
      }

      // 新增下一階段的節點
      this.data.push(this.data.length + 1);
    },
    // 新增當前節點的資料
    addCurrentNodeData(groupIndex, index) {
      const currentGroup = this.getGroupByIndex(this.data, groupIndex);
      const currentNode = currentGroup[index];

      // 若當前節點是數字，將其轉為陣列
      if (typeof currentNode === "number") {
        currentGroup.splice(index, 1, [currentNode]);
      }

      // 在當前節點內新增資料
      currentGroup[index].push(this.data.length + 1);
    },
    // 刪除節點或節點中的資料
    deleteNode(groupIndex, index, subIndex = null) {
      const currentGroup = this.getGroupByIndex(this.data, groupIndex);

      if (subIndex !== null) {
        // 如果指定了 subIndex，表示刪除的是節點中的資料
        currentGroup[index].splice(subIndex, 1);

        // 如果資料刪空，將陣列節點還原為數字節點
        if (currentGroup[index].length === 1) {
          currentGroup[index] = currentGroup[index][0];
        }
      } else {
        // 如果未指定 subIndex，表示刪除的是整個節點
        currentGroup.splice(index, 1);
      }
    },
    // 遞迴獲取指定層級的節點群組
    getGroupByIndex(data, groupIndex) {
      let group = data;
      for (let i = 0; i < groupIndex; i++) {
        group = group.find((item) => Array.isArray(item));
      }
      return group;
    },
  },
};
</script>
